import { ADD_MESSAGE, DELETE_MESSAGE } from './flashMessage.actionTypes';


export default function (state = {}, action) {
  switch (action.type) {
    case ADD_MESSAGE:
      return {
        ...state,
        title: action.message.title,
        text: action.message.text,
        type: action.message.type,
        intlTitleKey: action.message.intlTitleKey,
        intlTextKey: action.message.intlTextKey,
      };
    case DELETE_MESSAGE:
      return {};
    default:
      return state;
  }
}
